(() => {
  'use strict';

  const script = document.currentScript;
  const sectionId = script ? (script.dataset.sectionId || '') : '';
  const STORAGE_KEY = 'skaiiy_intelligence_v1';
  const LEGACY_HISTORY_KEY = 'skaiiyprints_last_viewed_products';
  const MAX_VIEWS = 500;
  const MAX_CATALOG = 1200;
  const MAX_TOKEN_WEIGHTS = 140;
  const VIEW_SIGNAL_COOLDOWN = 30 * 60 * 1000;

  const FAMILY_LABELS = {
    cosplay: 'Cosplay',
    jersey: 'Jerseys',
    tshirt: 'T-shirts',
    hoodie: 'Hoodies',
    sweater: 'Sweaters',
    pajama: 'Pajamas',
    pants: 'Pants',
    slippers: 'Slippers',
    socks: 'Socks',
    accessories: 'Accessories',
    figures: 'Figures',
    unknown: 'this style'
  };

  const FAMILY_RULES = [
    { name: 'cosplay', words: ['cosplay', 'costume', 'kigurumi', 'roleplay', 'bodysuit', 'bodysuits'] },
    { name: 'jersey', words: ['jersey', 'jerseys', 'soccer shirt', 'football shirt', 'football jersey'] },
    { name: 'hoodie', words: ['hoodie', 'hoodies', 'hooded sweatshirt'] },
    { name: 'sweater', words: ['sweater', 'sweaters', 'sweatshirt', 'sweatshirts', 'crewneck', 'crew neck'] },
    { name: 'tshirt', words: ['t-shirt', 't shirt', 'tshirt', 'tee shirt', 'graphic tee', 'vintage tee'] },
    { name: 'pajama', words: ['pajama', 'pajamas', 'pyjama', 'pyjamas', 'sleepwear', 'loungewear', 'onesie'] },
    { name: 'pants', words: ['pants', 'trousers', 'joggers', 'jogger', 'sweatpants', 'cargo pants'] },
    { name: 'slippers', words: ['slipper', 'slippers'] },
    { name: 'socks', words: ['sock', 'socks'] },
    { name: 'figures', words: ['figure', 'figures', 'figurine', 'figurines', 'statue', 'collectible figure'] },
    { name: 'accessories', words: ['wig', 'wigs', 'mask', 'masks', 'hat', 'cap', 'glove', 'gloves', 'accessory', 'accessories'] }
  ];


  const SERIES_RULES = [
    { key: 'jjk', label: 'JJK', words: ['jujutsu kaisen', 'jjk', 'gojo', 'satoru gojo', 'sukuna', 'itadori', 'yuji itadori', 'megumi fushiguro', 'nobara kugisaki', 'toji fushiguro', 'yuta okkotsu', 'geto suguru'] },
    { key: 'hxh', label: 'HXH', words: ['hunter x hunter', 'hxh', 'gon freecss', 'killua', 'kurapika', 'hisoka'] },
    { key: 'aot', label: 'AOT', words: ['attack on titan', 'aot', 'eren yeager', 'mikasa ackerman', 'levi ackerman', 'survey corps'] },
    { key: 'csm', label: 'CSM', words: ['chainsaw man', 'csm', 'denji', 'power', 'makima', 'aki hayakawa'] },
    { key: 'naruto', label: 'NARUTO', words: ['naruto', 'uzumaki', 'sasuke', 'itachi', 'kakashi', 'akatsuki'] },
    { key: 'black-clover', label: 'BLACK CLOVER', words: ['black clover', 'asta', 'yuno grynberryall', 'noelle silva'] },
    { key: 'demon-slayer', label: 'DEMON SLAYER', words: ['demon slayer', 'kimetsu no yaiba', 'tanjiro', 'nezuko', 'zenitsu', 'inosuke', 'rengoku'] },
    { key: 'one-piece', label: 'ONE PIECE', words: ['one piece', 'monkey d luffy', 'luffy', 'zoro', 'roronoa zoro', 'nami', 'sanji', 'boa hancock'] },
    { key: 'bleach', label: 'BLEACH', words: ['bleach', 'ichigo', 'rukia', 'aizen'] },
    { key: 'dragon-ball', label: 'DRAGON BALL', words: ['dragon ball', 'dragonball', 'goku', 'vegeta', 'gohan'] },
    { key: 'mha', label: 'MHA', words: ['my hero academia', 'boku no hero academia', 'mha', 'deku', 'bakugo', 'todoroki'] },
    { key: 'tokyo-revengers', label: 'TOKYO REVENGERS', words: ['tokyo revengers', 'mikey', 'manjiro sano', 'draken'] },
    { key: 'death-note', label: 'DEATH NOTE', words: ['death note', 'light yagami', 'ryuk'] },
    { key: 'pokemon', label: 'POKÉMON', words: ['pokemon', 'pokémon', 'pikachu', 'snorlax', 'gengar', 'umbreon'] },
    { key: 'blue-lock', label: 'BLUE LOCK', words: ['blue lock', 'isagi', 'bachira', 'nagi seishiro', 'rin itoshi'] },
    { key: 'haikyuu', label: 'HAIKYUU', words: ['haikyuu', 'hinata shoyo', 'kageyama'] },
    { key: 'solo-leveling', label: 'SOLO LEVELING', words: ['solo leveling', 'sung jinwoo', 'jinwoo'] },
    { key: 'spy-family', label: 'SPY X FAMILY', words: ['spy x family', 'spy family', 'anya forger', 'yor forger'] }
  ];

  const FAMILY_COLLECTION_CANDIDATES = {
    figures: ['figures', 'anime-figures', 'action-figures', 'collectible-figures'],
    cosplay: ['cosplay', 'cosplays', 'anime-cosplay', 'anime-cosplays'],
    tshirt: ['t-shirts', 'tshirts', 'vintage-t-shirts', 'anime-t-shirts'],
    hoodie: ['hoodies', 'vintage-hoodies', 'anime-hoodies'],
    sweater: ['sweaters', 'anime-sweaters', 'sweatshirts'],
    jersey: ['jerseys', 'anime-jerseys', 'soccer-jerseys'],
    pajama: ['pajamas', 'anime-pajamas', 'onesies'],
    pants: ['pants', 'anime-pants'],
    slippers: ['slippers'],
    socks: ['socks'],
    accessories: ['accessories', 'anime-accessories']
  };

  const GENERIC_COLLECTIONS = new Set([
    'all', 'frontpage', 'featured', 'featured-products', 'new', 'new-arrivals',
    'best-sellers', 'bestsellers', 'shop-all', 'products', 'anime', 'catalog'
  ]);

  const STOP_WORDS = new Set([
    'the', 'and', 'with', 'for', 'from', 'this', 'that', 'your', 'you', 'our', 'new',
    'anime', 'manga', 'official', 'style', 'premium', 'unisex', 'men', 'mens', 'women',
    'womens', 'girl', 'girls', 'boy', 'boys', 'adult', 'kids', 'kid', 'black', 'white',
    'blue', 'red', 'pink', 'green', 'yellow', 'purple', 'orange', 'grey', 'gray', 'brown',
    'cosplay', 'costume', 'kigurumi', 'bodysuit', 'jersey', 'hoodie', 'hoodies', 'sweater',
    'sweatshirt', 'shirt', 'tshirt', 'tee', 'pajama', 'pajamas', 'pyjama', 'pants', 'trousers',
    'slippers', 'socks', 'figure', 'figures', 'collection', 'collections', 'skaiiy', 'size',
    'edition', 'version', 'set', 'full', 'outfit', 'clothes', 'clothing'
  ]);

  const safeParse = (value, fallback) => {
    try {
      const parsed = JSON.parse(value);
      return parsed == null ? fallback : parsed;
    } catch (error) {
      return fallback;
    }
  };

  const normalize = value => String(value == null ? '' : value)
    .toLowerCase()
    .replace(/&amp;/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const list = value => {
    if (Array.isArray(value)) return value.filter(Boolean).map(String);
    if (value == null || value === '') return [];
    return String(value).split('|').map(item => item.trim()).filter(Boolean);
  };

  const unique = values => Array.from(new Set(values.filter(Boolean)));

  const hasPhrase = (text, phrase) => {
    const normalizedText = ` ${normalize(text)} `;
    const normalizedPhrase = ` ${normalize(phrase)} `;
    return normalizedText.includes(normalizedPhrase);
  };

  const classifyFamily = meta => {
    const strong = [meta.type, ...(meta.collections || []), ...(meta.tags || [])].join(' ');
    const title = meta.title || '';

    for (const rule of FAMILY_RULES) {
      if (rule.words.some(word => hasPhrase(strong, word))) return rule.name;
    }
    for (const rule of FAMILY_RULES) {
      if (rule.words.some(word => hasPhrase(title, word))) return rule.name;
    }
    return 'unknown';
  };


  const classifySeries = meta => {
    const haystack = [meta.title, meta.type, ...(meta.tags || []), ...(meta.collections || [])].join(' ');
    for (const rule of SERIES_RULES) {
      if (rule.words.some(word => hasPhrase(haystack, word))) return rule.key;
    }
    return 'unknown';
  };

  const seriesLabelFor = series => {
    const rule = SERIES_RULES.find(item => item.key === series);
    return rule ? rule.label : '';
  };

  const keywordsFor = meta => {
    const raw = [meta.title, meta.type, ...(meta.tags || []), ...(meta.collections || [])].join(' ');
    return unique(normalize(raw).split(' ').filter(token => token.length > 2 && !STOP_WORDS.has(token))).slice(0, 28);
  };

  const enrich = input => {
    const meta = {
      id: input && input.id != null ? String(input.id) : '',
      handle: input && input.handle ? String(input.handle) : '',
      title: input && input.title ? String(input.title) : '',
      url: input && input.url ? String(input.url) : '',
      image: input && input.image ? String(input.image) : '',
      price: input && input.price ? String(input.price) : '',
      type: input && input.type ? String(input.type) : '',
      tags: list(input && input.tags),
      collections: list(input && input.collections),
      ts: input && Number(input.ts) ? Number(input.ts) : Date.now()
    };
    meta.family = input && input.family ? String(input.family) : classifyFamily(meta);
    meta.series = input && input.series ? String(input.series) : classifySeries(meta);
    meta.seriesLabel = input && input.seriesLabel ? String(input.seriesLabel) : seriesLabelFor(meta.series);
    meta.keywords = Array.isArray(input && input.keywords) ? input.keywords : keywordsFor(meta);
    return meta;
  };

  const emptyState = () => ({
    version: 1,
    views: [],
    catalog: {},
    familyWeights: {},
    tokenWeights: {},
    signals: {},
    updatedAt: Date.now()
  });

  const readState = () => {
    let state = emptyState();
    try {
      state = Object.assign(state, safeParse(localStorage.getItem(STORAGE_KEY), {}));
    } catch (error) {}
    if (!Array.isArray(state.views)) state.views = [];
    if (!state.catalog || typeof state.catalog !== 'object') state.catalog = {};
    if (!state.familyWeights || typeof state.familyWeights !== 'object') state.familyWeights = {};
    if (!state.tokenWeights || typeof state.tokenWeights !== 'object') state.tokenWeights = {};
    if (!state.signals || typeof state.signals !== 'object') state.signals = {};
    return state;
  };

  const pruneObject = (object, max) => {
    const entries = Object.entries(object || {});
    if (entries.length <= max) return object || {};
    entries.sort((a, b) => Number((b[1] && b[1].ts) || b[1] || 0) - Number((a[1] && a[1].ts) || a[1] || 0));
    return Object.fromEntries(entries.slice(0, max));
  };

  const writeState = state => {
    state.views = (state.views || []).slice(0, MAX_VIEWS);
    state.catalog = pruneObject(state.catalog, MAX_CATALOG);
    const tokenEntries = Object.entries(state.tokenWeights || {}).sort((a, b) => Number(b[1]) - Number(a[1])).slice(0, MAX_TOKEN_WEIGHTS);
    state.tokenWeights = Object.fromEntries(tokenEntries);
    state.updatedAt = Date.now();
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {}
  };

  const addWeight = (object, key, amount) => {
    if (!key || key === 'unknown') return;
    object[key] = Math.min(40, Number(object[key] || 0) + amount);
  };

  const learnSignal = (state, product, weight, signalName) => {
    const meta = enrich(product);
    if (!meta.id) return;

    state.catalog[meta.id] = Object.assign({}, meta, { ts: Date.now() });
    addWeight(state.familyWeights, meta.family, weight);
    meta.keywords.slice(0, 10).forEach(token => addWeight(state.tokenWeights, token, weight * 0.45));
    state.signals[`${signalName}:${meta.id}`] = Date.now();
  };

  const rememberView = (state, product) => {
    const meta = enrich(product);
    if (!meta.id) return;

    const now = Date.now();
    const previousSignal = Number(state.signals[`view:${meta.id}`] || 0);
    const shouldLearn = !previousSignal || (now - previousSignal) > VIEW_SIGNAL_COOLDOWN;

    state.views = [Object.assign({}, meta, { ts: now })]
      .concat(state.views.filter(item => item && String(item.id) !== meta.id))
      .slice(0, MAX_VIEWS);
    state.catalog[meta.id] = Object.assign({}, meta, { ts: now });

    if (shouldLearn) learnSignal(state, meta, 1, 'view');
  };

  const migrateLegacyHistory = state => {
    if (state.views.length > 1) return;
    let legacy = [];
    try {
      legacy = safeParse(localStorage.getItem(LEGACY_HISTORY_KEY), []);
    } catch (error) {}
    if (!Array.isArray(legacy)) return;

    legacy.forEach(item => {
      if (!item || item.id == null) return;
      const meta = enrich(item);
      if (!meta.id || state.views.some(view => view.id === meta.id)) return;
      state.views.push(meta);
      state.catalog[meta.id] = meta;
    });
    state.views = state.views.slice(0, MAX_VIEWS);
  };

  const intersectionCount = (a, b) => {
    const right = new Set((b || []).map(normalize));
    return unique((a || []).map(normalize)).filter(value => value && right.has(value)).length;
  };

  const scoreProduct = (candidateInput, currentInput, stateInput) => {
    const candidate = enrich(candidateInput);
    const current = enrich(currentInput);
    const state = stateInput || readState();

    if (!candidate.id || candidate.id === current.id) return -Infinity;

    const sameCollection = intersectionCount(candidate.collections, current.collections);
    const sameTags = intersectionCount(candidate.tags, current.tags);
    const sameKeywords = intersectionCount(candidate.keywords, current.keywords);

    // Category safety is absolute. If the shopper is on a figure, cosplay, hoodie,
    // etc., recommendations stay in that product family even when another item
    // shares the same anime/character keywords.
    if (current.family !== 'unknown' && candidate.family !== current.family) {
      return -Infinity;
    }

    let score = 0;
    if (current.family !== 'unknown' && candidate.family === current.family) score += 110;
    else if (candidate.family === 'unknown') score += 4;

    if (current.series !== 'unknown' && candidate.series === current.series) score += 130;
    else if (current.series !== 'unknown' && candidate.series !== 'unknown') score += 12;

    score += Math.min(36, sameCollection * 18);
    score += Math.min(24, sameTags * 6);
    score += Math.min(28, sameKeywords * 4);
    score += Math.min(14, Number(state.familyWeights[candidate.family] || 0) * 1.5);

    const learnedTokenScore = candidate.keywords.slice(0, 12)
      .reduce((sum, token) => sum + Math.min(2.2, Number(state.tokenWeights[token] || 0) * 0.35), 0);
    score += Math.min(14, learnedTokenScore);

    const wasViewed = state.views.some(item => item && String(item.id) === candidate.id);
    if (wasViewed) score -= 10;

    return score;
  };

  const rankProducts = (candidates, current, state) => {
    const seen = new Set();
    const currentMeta = enrich(current);
    return (candidates || [])
      .map(enrich)
      .filter(item => item.id && !seen.has(item.id) && seen.add(item.id))
      .map(item => {
        const score = scoreProduct(item, currentMeta, state);
        let tier = 0;
        if (currentMeta.series !== 'unknown') {
          if (item.series === currentMeta.series) tier = 0;
          else if (item.series !== 'unknown') tier = 1;
          else tier = 2;
        }
        return { product: item, score, tier };
      })
      .filter(row => Number.isFinite(row.score) && row.score > 0)
      .sort((a, b) => (a.tier - b.tier) || (b.score - a.score))
      .map(row => Object.assign({}, row.product, { _score: row.score, _tier: row.tier }));
  };

  const formatCurrency = (value, currency) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: number % 1 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(number);
    } catch (error) {
      return `${currency || '$'} ${number.toFixed(number % 1 ? 2 : 0)}`;
    }
  };

  const productFromCollectionJson = (product, collectionHandle, currency) => {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const numericPrices = variants.map(variant => Number(variant.price)).filter(Number.isFinite);
    const minPrice = numericPrices.length ? Math.min(...numericPrices) : NaN;
    const maxPrice = numericPrices.length ? Math.max(...numericPrices) : NaN;
    const hasRange = Number.isFinite(minPrice) && Number.isFinite(maxPrice) && Math.abs(maxPrice - minPrice) > 0.001;
    const image = product.image && product.image.src
      ? product.image.src
      : (Array.isArray(product.images) && product.images[0]
        ? (product.images[0].src || product.images[0])
        : '');

    return enrich({
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.handle ? `/products/${product.handle}` : '',
      image,
      price: Number.isFinite(minPrice) ? `${hasRange ? 'From ' : ''}${formatCurrency(minPrice, currency)}` : '',
      type: product.product_type || product.type || '',
      tags: product.tags || [],
      collections: [collectionHandle]
    });
  };

  const productFromCard = card => enrich({
    id: card.dataset.productId,
    handle: card.dataset.productHandle,
    title: card.dataset.productTitle || card.querySelector('.dg-mobile-card__title')?.textContent || '',
    url: card.dataset.productUrl || card.querySelector('a')?.getAttribute('href') || '',
    image: card.dataset.productImage || card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '',
    price: card.dataset.productPrice || card.querySelector('.dg-mobile-card__price')?.textContent || '',
    type: card.dataset.productType || '',
    tags: list(card.dataset.productTags),
    collections: list(card.dataset.productCollections)
  });

  const escapeAttribute = value => String(value == null ? '' : value);

  const createCard = metaInput => {
    const meta = enrich(metaInput);
    const card = document.createElement('div');
    card.className = 'dg-mobile-card dg-mobile-card--smart';
    card.setAttribute('data-skaiiy-intel-card', '');
    card.dataset.productId = meta.id;
    card.dataset.productHandle = meta.handle;
    card.dataset.productTitle = meta.title;
    card.dataset.productUrl = meta.url;
    card.dataset.productType = meta.type;
    card.dataset.productTags = meta.tags.join('|');
    card.dataset.productCollections = meta.collections.join('|');
    card.dataset.productImage = meta.image;
    card.dataset.productPrice = meta.price;
    card.dataset.productFamily = meta.family;
    card.dataset.productSeries = meta.series;

    const link = document.createElement('a');
    link.className = 'dg-mobile-card__link';
    link.href = meta.url || '#';

    const imageWrap = document.createElement('div');
    imageWrap.className = 'dg-mobile-card__image';

    if (meta.image) {
      const image = document.createElement('img');
      image.src = escapeAttribute(meta.image);
      image.alt = meta.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      imageWrap.appendChild(image);
    }

    const title = document.createElement('div');
    title.className = 'dg-mobile-card__title';
    title.textContent = meta.title;

    const metaRow = document.createElement('div');
    metaRow.className = 'dg-mobile-card__meta';

    const price = document.createElement('div');
    price.className = 'dg-mobile-card__price';
    price.textContent = meta.price;
    metaRow.appendChild(price);

    if (meta.seriesLabel) {
      const series = document.createElement('span');
      series.className = 'dg-mobile-card__series';
      series.textContent = meta.seriesLabel;
      metaRow.appendChild(series);
    }

    link.append(imageWrap, title, metaRow);
    card.appendChild(link);

    const fav = document.createElement('button');
    fav.type = 'button';
    fav.className = 'dg-mobile-card__wishlist';
    fav.setAttribute('aria-label', 'Add to favourites');
    fav.setAttribute('aria-pressed', 'false');
    fav.setAttribute('data-fav-toggle-product', '');
    fav.dataset.productId = meta.id;
    fav.dataset.productUrl = meta.url;
    fav.dataset.productTitle = meta.title;
    fav.dataset.productImage = meta.image;
    fav.dataset.productPrice = meta.price;
    fav.innerHTML = '<svg class="dg-bookmark-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false"><path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"/></svg>';
    card.appendChild(fav);

    return card;
  };

  const collectionSpecificity = (handle, current) => {
    const normalizedHandle = normalize(handle);
    if (!normalizedHandle || GENERIC_COLLECTIONS.has(normalizedHandle.replace(/ /g, '-'))) return -100;
    let score = 0;
    if (current.family !== 'unknown' && hasPhrase(normalizedHandle, current.family)) score += 80;
    current.keywords.forEach(token => {
      if (hasPhrase(normalizedHandle, token)) score += 8;
    });
    if (normalizedHandle.split(' ').length >= 2) score += 4;
    return score;
  };

  const init = () => {
    const root = document.querySelector('[data-skaiiy-ai-recommendations]') || document.querySelector('[data-dg-mobile-recommendations]');
    const configElement = document.getElementById(`SkaiiyProductConfig-${sectionId}`);
    if (!root || !configElement) return;

    const config = safeParse(configElement.textContent || '{}', {});
    if (!config.product || !config.product.id) return;

    const current = enrich(config.product);
    const currency = config.currency || 'USD';
    const pageSize = Math.max(2, Math.min(20, Number(config.recommendationPageSize || config.recommendationLimit) || 8));
    const state = readState();
    migrateLegacyHistory(state);
    rememberView(state, current);
    writeState(state);

    /* Desktop placement
       Keep one shared More Suggestions / Last Viewed component. On desktop,
       move it into the theme's existing "You may also like" position and hide
       only that old native recommendation section. Mobile stays exactly where
       the main-product template placed it. */
    const originalMarker = document.createComment('skaiiy-recommendations-original-position');
    if (root.parentNode) root.parentNode.insertBefore(originalMarker, root);
    let hiddenNativeDesktopSection = null;

    const findNativeDesktopRecommendationSection = () => {
      const headingSelectors = [
        '.related-products__heading',
        '.product-recommendations__heading',
        'h1', 'h2', 'h3', 'h4'
      ].join(',');

      const headings = Array.from(document.querySelectorAll(headingSelectors));
      const wanted = [
        'you may also like',
        'you might also like',
        'you may like',
        'recommended for you'
      ];

      for (const heading of headings) {
        if (!heading || root.contains(heading)) continue;
        const text = normalize(heading.textContent || '');
        if (!wanted.some(label => text === label || text.includes(label))) continue;

        const section = heading.closest('.shopify-section')
          || heading.closest('section')
          || heading.closest('product-recommendations')
          || heading.parentElement;

        if (!section || section === root || section.contains(root) || root.contains(section)) continue;
        return section;
      }
      return null;
    };

    const restoreNativeDesktopSection = () => {
      if (!hiddenNativeDesktopSection) return;
      hiddenNativeDesktopSection.classList.remove('skaiiy-native-recommendations-hidden');
      hiddenNativeDesktopSection = null;
    };

    const syncDesktopPlacement = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      if (!isDesktop) {
        restoreNativeDesktopSection();
        if (originalMarker.parentNode && root.previousSibling !== originalMarker) {
          originalMarker.parentNode.insertBefore(root, originalMarker.nextSibling);
        }
        root.classList.remove('is-skaiiy-desktop-placement');
        return;
      }

      const nativeSection = findNativeDesktopRecommendationSection();
      if (!nativeSection || !nativeSection.parentNode) {
        root.classList.add('is-skaiiy-desktop-placement');
        return;
      }

      if (hiddenNativeDesktopSection && hiddenNativeDesktopSection !== nativeSection) {
        restoreNativeDesktopSection();
      }

      hiddenNativeDesktopSection = nativeSection;
      hiddenNativeDesktopSection.classList.add('skaiiy-native-recommendations-hidden');
      nativeSection.parentNode.insertBefore(root, nativeSection);
      root.classList.add('is-skaiiy-desktop-placement');
    };

    syncDesktopPlacement();
    [500, 1400, 3000].forEach(delay => setTimeout(syncDesktopPlacement, delay));
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', syncDesktopPlacement);
    else if (desktopMedia.addListener) desktopMedia.addListener(syncDesktopPlacement);

    const scrollToRecommendationTop = () => {
      const top = Math.max(0, window.scrollY + root.getBoundingClientRect().top - 18);
      window.scrollTo({ top, behavior: 'smooth' });
    };

    const makeShowLessButton = (loadMoreButton, panelName) => {
      if (!loadMoreButton || !loadMoreButton.parentNode) return null;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dg-mobile-recommendations__show-less';
      button.setAttribute('data-skaiiy-show-less', panelName);
      button.textContent = 'Show less';
      button.hidden = true;
      loadMoreButton.insertAdjacentElement('afterend', button);
      return button;
    };

    const reason = root.querySelector('[data-skaiiy-ai-reason]');
    const moreReason = `More suggestions related to ${current.title}`;
    if (reason) reason.textContent = moreReason;

    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-dg-recommendations-tab]');
      if (!tab || !reason) return;
      reason.textContent = tab.dataset.dgRecommendationsTab === 'viewed'
        ? 'Last viewed products'
        : moreReason;
    });

    const rememberCatalog = products => {
      products.forEach(product => {
        const meta = enrich(product);
        if (meta.id) state.catalog[meta.id] = Object.assign({}, meta, { ts: Date.now() });
      });
      writeState(state);
    };

    let visibleViewedCount = pageSize;
    const viewedLoadMore = root.querySelector('[data-skaiiy-load-more="viewed"]');
    const viewedShowLess = makeShowLessButton(viewedLoadMore, 'viewed');

    const renderViewed = () => {
      const grid = root.querySelector('[data-skaiiy-ai-grid="viewed"]');
      const empty = root.querySelector('[data-skaiiy-ai-viewed-empty]');
      if (!grid) return;

      const allPrevious = state.views
        .map(enrich)
        .filter(item => item.id && item.id !== current.id);

      const visible = allPrevious.slice(0, visibleViewedCount);
      grid.replaceChildren(...visible.map((item, index) => {
        const card = createCard(item);
        card.style.setProperty('--skaiiy-card-order', String(index));
        return card;
      }));

      if (empty) empty.hidden = allPrevious.length > 0;
      grid.hidden = allPrevious.length === 0;
      if (viewedLoadMore) viewedLoadMore.hidden = allPrevious.length <= visible.length;
      if (viewedShowLess) viewedShowLess.hidden = visibleViewedCount <= pageSize || allPrevious.length <= pageSize;
    };

    if (viewedLoadMore) {
      viewedLoadMore.addEventListener('click', () => {
        visibleViewedCount += pageSize;
        renderViewed();
      });
    }

    if (viewedShowLess) {
      viewedShowLess.addEventListener('click', () => {
        visibleViewedCount = pageSize;
        renderViewed();
        requestAnimationFrame(scrollToRecommendationTop);
      });
    }

    const fetchedCollectionPages = new Map();
    const fetchCollectionPage = async (handle, page) => {
      if (!handle || page < 1) return { products: [], hasMore: false };
      const key = `${handle}::${page}`;
      if (fetchedCollectionPages.has(key)) return fetchedCollectionPages.get(key);

      const limit = 50;
      const promise = fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}&page=${page}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(response => response.ok ? response.json() : Promise.reject(new Error(`Collection ${handle} returned ${response.status}`)))
        .then(data => {
          const raw = Array.isArray(data.products) ? data.products : [];
          return {
            products: raw.map(product => productFromCollectionJson(product, handle, currency)),
            hasMore: raw.length === limit
          };
        })
        .catch(() => ({ products: [], hasMore: false }));

      fetchedCollectionPages.set(key, promise);
      return promise;
    };

    const currentHandles = unique(current.collections)
      .filter(handle => handle && !GENERIC_COLLECTIONS.has(String(handle).toLowerCase()));

    const seriesHandles = currentHandles.filter(handle => {
      if (current.series === 'unknown') return false;
      return classifySeries({ title: '', type: '', tags: [], collections: [handle] }) === current.series;
    });

    const familyHandles = currentHandles.filter(handle => {
      if (current.family === 'unknown') return false;
      return classifyFamily({ title: '', type: '', tags: [], collections: [handle] }) === current.family;
    });

    const rankedCurrentHandles = currentHandles
      .slice()
      .sort((a, b) => collectionSpecificity(b, current) - collectionSpecificity(a, current));

    const primaryHandles = unique([
      ...seriesHandles,
      ...familyHandles,
      ...rankedCurrentHandles
    ]).slice(0, 5);

    const fallbackHandles = current.family !== 'unknown'
      ? (FAMILY_COLLECTION_CANDIDATES[current.family] || []).filter(handle => !primaryHandles.includes(handle))
      : [];

    const sourceHandles = unique([...primaryHandles, ...fallbackHandles]);
    const sourceState = new Map(sourceHandles.map(handle => [handle, { nextPage: 1, exhausted: false }]));
    const candidateMap = new Map();

    const addCandidates = products => {
      (products || []).forEach(product => {
        const meta = enrich(product);
        if (!meta.id || meta.id === current.id) return;
        candidateMap.set(meta.id, meta);
      });
    };

    Object.values(state.catalog || {}).forEach(item => addCandidates([item]));

    const getRanked = () => rankProducts(Array.from(candidateMap.values()), current, state);

    let loadRound = 0;
    const fetchNextSourceRound = async () => {
      const active = sourceHandles.filter(handle => {
        const source = sourceState.get(handle);
        return source && !source.exhausted;
      });
      if (!active.length) return false;

      const results = await Promise.all(active.map(async handle => {
        const source = sourceState.get(handle);
        const page = source.nextPage;
        const result = await fetchCollectionPage(handle, page);
        source.nextPage += 1;
        if (!result.hasMore || !result.products.length) source.exhausted = true;
        return result.products;
      }));

      results.flat().forEach(items => addCandidates([items].flat()));
      loadRound += 1;
      return results.some(items => items.length > 0);
    };

    const hasUnexhaustedSources = () => sourceHandles.some(handle => {
      const source = sourceState.get(handle);
      return source && !source.exhausted;
    });

    const ensureMoreCandidates = async targetCount => {
      let ranked = getRanked();
      let safety = 0;
      while (ranked.length < targetCount && hasUnexhaustedSources() && safety < 20) {
        const gotAny = await fetchNextSourceRound();
        ranked = getRanked();
        safety += 1;
        if (!gotAny && !hasUnexhaustedSources()) break;
      }
      return ranked;
    };

    let visibleMoreCount = pageSize;
    let buildToken = 0;
    let lastInternalMutation = 0;
    let loadMoreBusy = false;
    const moreLoadMore = root.querySelector('[data-skaiiy-load-more="more"]');
    const moreShowLess = makeShowLessButton(moreLoadMore, 'more');

    const renderMore = async ({ ensure = true } = {}) => {
      const token = ++buildToken;
      const recommendationsElement = root.querySelector('product-recommendations');
      if (!recommendationsElement) return;

      let grid = recommendationsElement.querySelector('[data-skaiiy-ai-grid="more"]');
      const serverCards = Array.from(recommendationsElement.querySelectorAll('[data-skaiiy-intel-card]'));
      addCandidates(serverCards.map(productFromCard));

      let ranked = ensure
        ? await ensureMoreCandidates(visibleMoreCount)
        : getRanked();
      if (token !== buildToken) return;

      rememberCatalog(ranked);
      const visible = ranked.slice(0, visibleMoreCount);

      if (!grid) {
        grid = document.createElement('div');
        grid.className = 'dg-mobile-recommendations__grid';
        grid.setAttribute('data-skaiiy-ai-grid', 'more');
        recommendationsElement.appendChild(grid);
      }

      const signature = visible.map(item => item.id).join('|');
      if (grid.dataset.skaiiyAiRendered !== signature) {
        lastInternalMutation = Date.now();
        grid.dataset.skaiiyAiRendered = signature;
        grid.replaceChildren(...visible.map((item, index) => {
          const card = createCard(item);
          card.style.setProperty('--skaiiy-card-order', String(index));
          return card;
        }));
      }

      const empty = root.querySelector('[data-skaiiy-ai-more-empty]');
      if (empty) empty.hidden = visible.length > 0 || hasUnexhaustedSources();
      grid.hidden = visible.length === 0;

      if (moreLoadMore) {
        const bufferedMore = ranked.length > visible.length;
        moreLoadMore.hidden = !(bufferedMore || hasUnexhaustedSources());
        moreLoadMore.disabled = loadMoreBusy;
        moreLoadMore.classList.toggle('is-loading', loadMoreBusy);
        moreLoadMore.textContent = loadMoreBusy ? 'Loading…' : 'Load more';
      }
      if (moreShowLess) moreShowLess.hidden = visibleMoreCount <= pageSize;
    };

    if (moreLoadMore) {
      moreLoadMore.addEventListener('click', async () => {
        if (loadMoreBusy) return;
        loadMoreBusy = true;
        moreLoadMore.disabled = true;
        moreLoadMore.classList.add('is-loading');
        moreLoadMore.textContent = 'Loading…';
        visibleMoreCount += pageSize;
        try {
          await renderMore({ ensure: true });
        } finally {
          loadMoreBusy = false;
          await renderMore({ ensure: false });
        }
      });
    }

    if (moreShowLess) {
      moreShowLess.addEventListener('click', async () => {
        if (loadMoreBusy) return;
        visibleMoreCount = pageSize;
        await renderMore({ ensure: false });
        requestAnimationFrame(scrollToRecommendationTop);
      });
    }

    renderViewed();
    renderMore({ ensure: true });

    const recommendationsElement = root.querySelector('product-recommendations');
    if (recommendationsElement && window.MutationObserver) {
      let timer = null;
      const observer = new MutationObserver(() => {
        if (Date.now() - lastInternalMutation < 160) return;
        clearTimeout(timer);
        timer = setTimeout(() => renderMore({ ensure: false }), 120);
      });
      observer.observe(recommendationsElement, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 8000);
    }

    [700, 1800, 3500].forEach(delay => setTimeout(() => renderMore({ ensure: false }), delay));

    root.addEventListener('pointerdown', event => {
      const card = event.target.closest('.dg-mobile-card');
      if (!card || !root.contains(card)) return;
      const meta = productFromCard(card);
      if (!meta.id) return;

      if (event.target.closest('[data-fav-toggle-product]')) {
        learnSignal(state, meta, 2.5, 'wishlist');
      } else if (event.target.closest('a')) {
        learnSignal(state, meta, 1.25, 'recommendation-click');
      }
      state.catalog[meta.id] = Object.assign({}, meta, { ts: Date.now() });
      writeState(state);
    }, { passive: true });

    const publicApi = {
      version: '1.3.1',
      sectionId,
      classifyProduct: product => classifyFamily(enrich(product)),
      classifySeries: product => classifySeries(enrich(product)),
      scoreProduct: (candidate, reference = current) => scoreProduct(candidate, reference, readState()),
      rankProducts: (candidates, reference = current) => rankProducts(candidates, reference, readState()),
      rememberProduct: (product, signal = 'manual', weight = 1) => {
        const latest = readState();
        learnSignal(latest, enrich(product), Number(weight) || 1, signal);
        writeState(latest);
      },
      getProfile: () => {
        const latest = readState();
        return {
          familyWeights: Object.assign({}, latest.familyWeights),
          tokenWeights: Object.assign({}, latest.tokenWeights),
          recentViews: latest.views.map(enrich),
          catalogSize: Object.keys(latest.catalog || {}).length
        };
      },
      getCurrentProduct: () => Object.assign({}, current),
      getRecommendationPageSize: () => pageSize
    };

    window.SkaiiyAI = Object.assign(window.SkaiiyAI || {}, publicApi);
    window.dispatchEvent(new CustomEvent('skaiiy:ai:ready', {
      detail: { version: publicApi.version, sectionId, family: current.family }
    }));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
